import { action } from 'typesafe-actions';
import { asyncAction } from 'store/utils/promiseAction';

import {
  CompaniesTypes,
  CompanyInterface,
  CompanyReportInterface,
  SelectedReportTypesInterface,
  CompanyAuthInterface,
  PaymentConfigInterface,
  BoardingHistoryInterface,
  CompanyBoletoConfigListRequestInterface,
} from './types';

// List Company
export const listCompaniesRequest = (payload: {
  body?: object;
  filtering?: boolean;
  loading?: boolean;
  isCsvFull?: boolean;
}) => action(CompaniesTypes.LIST_COMPANIES_REQUEST, payload);
export const listCompaniesSuccess = (payload: {
  companiesList: CompanyInterface[];
  companiesListFull: CompanyInterface[];
  totalCount: number;
  isCsvFull?: boolean;
}) => action(CompaniesTypes.LIST_COMPANIES_SUCCESS, payload);
export const listCompaniesFaliure = () =>
  action(CompaniesTypes.LIST_COMPANIES_FAILURE);

// Get Company
export const getCompanyRequest = (payload: object) =>
  action(CompaniesTypes.GET_COMPANY_REQUEST, payload);
export const getCompanySuccess = (payload: { companyData: CompanyInterface }) =>
  action(CompaniesTypes.GET_COMPANY_SUCCESS, payload);
export const getCompanyFaliure = () =>
  action(CompaniesTypes.GET_COMPANY_FAILURE);

// Get Company
export const authCompanyRequest = (payload: {
  document: string;
  password: string;
}) => action(CompaniesTypes.AUTH_COMPANIES_REQUEST, payload);
export const authCompanySuccess = (payload: {
  companyAuth: CompanyAuthInterface;
}) => action(CompaniesTypes.AUTH_COMPANIES_SUCCESS, payload);
export const authCompanyFaliure = () =>
  action(CompaniesTypes.AUTH_COMPANIES_FAILURE);

// Company Report
export const reportCompanyRequest = (payload: any) =>
  action(CompaniesTypes.REPORT_COMPANY_REQUEST, payload);

export const reportCompanySuccess = (payload: {
  companyReportList: CompanyReportInterface[];
  totalCount: number;
}) => action(CompaniesTypes.REPORT_COMPANY_SUCCESS, payload);

export const reportCompanyFailure = () =>
  action(CompaniesTypes.REPORT_COMPANY_FAILURE);

export const forgotPasswordRequest = (payload: {
  id: string;
  internal?: boolean;
}) => action(CompaniesTypes.FORGOT_PASSWORD_REQUEST, payload);
export const forgotPasswordSuccess = () =>
  action(CompaniesTypes.FORGOT_PASSWORD_SUCCESS);
export const forgotPasswordFailure = () =>
  action(CompaniesTypes.FORGOT_PASSWORD_FAILURE);

// Filter Company
export const filterCompaniesRequest = (payload: object) =>
  asyncAction(CompaniesTypes.FILTER_COMPANIES_REQUEST, payload);
export const filterCompaniesSuccess = (payload: {
  companiesList: CompanyInterface[];
  totalCount: number;
}) => action(CompaniesTypes.FILTER_COMPANIES_SUCCESS, payload);
export const filterCompaniesFaliure = () =>
  action(CompaniesTypes.FILTER_COMPANIES_FAILURE);

// Create Company
export const createCompanyRequest = (payload: {
  body: object;
  redirectTo?: string;
}) => asyncAction(CompaniesTypes.CREATE_COMPANY_REQUEST, payload);
export const createCompanySuccess = (payload: {
  companyCreated: CompanyInterface;
}) => action(CompaniesTypes.CREATE_COMPANY_SUCCESS, payload);
export const createCompanyFailure = () =>
  action(CompaniesTypes.CREATE_COMPANY_FAILURE);

// Update Company
export const updateCompanyRequest = (payload: {
  body: object;
  redirectTo?: string;
}) => action(CompaniesTypes.UPDATE_COMPANY_REQUEST, payload);
export const updateCompanySuccess = (payload: {
  companyData: CompanyInterface;
}) => action(CompaniesTypes.UPDATE_COMPANY_SUCCESS, payload);
export const updateCompanyFailure = () =>
  action(CompaniesTypes.UPDATE_COMPANY_FAILURE);

// Update Report Limit
export const updateReportLimitRequest = (payload: { body: object }) =>
  action(CompaniesTypes.UPDATE_REPORT_LIMIT_REQUEST, payload);
export const updateReportLimitSuccess = (payload: {
  companyData: CompanyInterface;
}) => action(CompaniesTypes.UPDATE_REPORT_LIMIT_SUCCESS, payload);
export const updateReportLimitFailure = () =>
  action(CompaniesTypes.UPDATE_REPORT_LIMIT_FAILURE);

// Delete Company
export const deleteCompanyRequest = (payload: {
  body: object;
  isDeleteList?: boolean;
}) => action(CompaniesTypes.DELETE_COMPANY_REQUEST, payload);
export const deleteCompanySuccess = () =>
  action(CompaniesTypes.DELETE_COMPANY_SUCCESS);
export const deleteCompanyFailure = () =>
  action(CompaniesTypes.DELETE_COMPANY_FAILURE);

export const setSelectedType = (payload: {
  selectedType: SelectedReportTypesInterface[];
}) => action(CompaniesTypes.SET_SELECTED_TYPE, payload);

export const setSelectedStatus = (payload: {
  selectedStatus: string | number;
}) => action(CompaniesTypes.SET_SELECTED_STATUS, payload);

export const setSelectedPaymentType = (payload: {
  selectedPaymentType: SelectedReportTypesInterface[];
}) => action(CompaniesTypes.SET_SELECTED_PAYMENT_TYPE, payload);

// Forgot Company
export const forgotCompanyRequest = (payload: {
  document?: string;
  id?: string;
}) => action(CompaniesTypes.FORGOT_COMPANIES_REQUEST, payload);
export const forgotCompanySuccess = () =>
  action(CompaniesTypes.FORGOT_COMPANIES_SUCCESS);
export const forgotCompanyFailure = () =>
  action(CompaniesTypes.FORGOT_COMPANIES_FAILURE);

// List Payment Method
export const listPaymentMethodRequest = (payload: object) =>
  action(CompaniesTypes.LIST_MANAGEMENT_PAYMENT_REQUEST, payload);
export const listPaymentMethodSuccess = (payload: {
  paymentMethodList: PaymentConfigInterface[];
}) => action(CompaniesTypes.LIST_MANAGEMENT_PAYMENT_SUCCESS, payload);
export const listPaymentMethodFaliure = () =>
  action(CompaniesTypes.LIST_MANAGEMENT_PAYMENT_FAILURE);

// Create Payment Method
export const createPaymentMethodRequest = (payload: { body?: object }) =>
  action(CompaniesTypes.CREATE_MANAGEMENT_PAYMENT_REQUEST, payload);
export const createPaymentMethodSuccess = (payload: {
  paymentMethodData: PaymentConfigInterface;
}) => action(CompaniesTypes.CREATE_MANAGEMENT_PAYMENT_SUCCESS, payload);
export const createPaymentMethodFailure = () =>
  action(CompaniesTypes.CREATE_MANAGEMENT_PAYMENT_FAILURE);

// Update Payment Method
export const updatePaymentMethodRequest = (payload: { body?: object }) =>
  action(CompaniesTypes.UPDATE_MANAGEMENT_PAYMENT_REQUEST, payload);
export const updatePaymentMethodSuccess = (payload: {
  paymentMethodData: PaymentConfigInterface;
}) => action(CompaniesTypes.UPDATE_MANAGEMENT_PAYMENT_SUCCESS, payload);
export const updatePaymentMethodFailure = () =>
  action(CompaniesTypes.UPDATE_MANAGEMENT_PAYMENT_FAILURE);

// Update Payment Method
export const updatePaymentMethodStatusRequest = (payload: object) =>
  action(CompaniesTypes.UPDATE_MANAGEMENT_PAYMENT_STATUS_REQUEST, payload);
export const updatePaymentMethodStatusSuccess = (payload: {
  paymentMethodData: PaymentConfigInterface;
}) => action(CompaniesTypes.UPDATE_MANAGEMENT_PAYMENT_STATUS_SUCCESS, payload);
export const updatePaymentMethodStatusFailure = () =>
  action(CompaniesTypes.UPDATE_MANAGEMENT_PAYMENT_STATUS_FAILURE);

// Delete Payment Method
export const deletePaymentMethodRequest = (payload: object) =>
  action(CompaniesTypes.DELETE_MANAGEMENT_PAYMENT_REQUEST, payload);
export const deletePaymentMethodSuccess = () =>
  action(CompaniesTypes.DELETE_MANAGEMENT_PAYMENT_SUCCESS);
export const deletePaymentMethodFailure = () =>
  action(CompaniesTypes.DELETE_MANAGEMENT_PAYMENT_FAILURE);

// Create Vehicle
export const createVehicleRequest = (payload: { body: object }) =>
  asyncAction(CompaniesTypes.CREATE_VEHICLE_REQUEST, payload);
export const createVehicleSuccess = () =>
  action(CompaniesTypes.CREATE_VEHICLE_SUCCESS);
export const createVehicleFailure = () =>
  action(CompaniesTypes.CREATE_VEHICLE_FAILURE);

// Update Company
export const updateVehicleRequest = (payload: { body: object }) =>
  action(CompaniesTypes.UPDATE_VEHICLE_REQUEST, payload);
export const updateVehicleSuccess = () =>
  action(CompaniesTypes.UPDATE_VEHICLE_SUCCESS);
export const updateVehicleFailure = () =>
  action(CompaniesTypes.UPDATE_VEHICLE_FAILURE);

// Delete Vehicle
export const deleteVehicleRequest = (payload: object) =>
  action(CompaniesTypes.DELETE_VEHICLE_REQUEST, payload);
export const deleteVehicleSuccess = () =>
  action(CompaniesTypes.DELETE_VEHICLE_SUCCESS);
export const deleteVehicleFailure = () =>
  action(CompaniesTypes.DELETE_VEHICLE_FAILURE);

// List Company
export const listBoardingHistoryRequest = (payload: { body?: object }) =>
  action(CompaniesTypes.LIST_BOARDING_HISTORY_REQUEST, payload);
export const listBoardingHistorySuccess = (payload: {
  boardingHistoryList: BoardingHistoryInterface[];
}) => action(CompaniesTypes.LIST_BOARDING_HISTORY_SUCCESS, payload);
export const listBoardingHistoryFaliure = () =>
  action(CompaniesTypes.LIST_BOARDING_HISTORY_FAILURE);

// Company Boleto Config Create Many
export const companyBoletoConfigCreateManyRequest = (payload: object) =>
  action(CompaniesTypes.COMPANY_BOLETO_CONFIG_CREATE_MANY_REQUEST, payload);
export const companyBoletoConfigCreateManySuccess = () =>
  action(CompaniesTypes.COMPANY_BOLETO_CONFIG_CREATE_MANY_SUCCESS);
export const companyBoletoConfigCreateManyFaliure = () =>
  action(CompaniesTypes.COMPANY_BOLETO_CONFIG_CREATE_MANY_FAILURE);

// Company Boleto Config List
export const companyBoletoConfigListRequest = (payload: object) =>
  action(CompaniesTypes.COMPANY_BOLETO_CONFIG_LIST_REQUEST, payload);
export const companyBoletoConfigListSuccess = (payload: {
  companyBoletoConfigList: CompanyBoletoConfigListRequestInterface[];
}) => action(CompaniesTypes.COMPANY_BOLETO_CONFIG_LIST_SUCCESS, payload);
export const companyBoletoConfigListFaliure = () =>
  action(CompaniesTypes.COMPANY_BOLETO_CONFIG_LIST_FAILURE);

// Company Boleto Config Update Many
export const companyBoletoConfigUpdateManyRequest = (payload: object) =>
  action(CompaniesTypes.COMPANY_BOLETO_CONFIG_UPDATE_MANY_REQUEST, payload);
export const companyBoletoConfigUpdateManySuccess = () =>
  action(CompaniesTypes.COMPANY_BOLETO_CONFIG_UPDATE_MANY_SUCCESS);
export const companyBoletoConfigUpdateManyFaliure = () =>
  action(CompaniesTypes.COMPANY_BOLETO_CONFIG_UPDATE_MANY_FAILURE);

// Company Boleto Config Delete
export const companyBoletoConfigDeleteRequest = (payload: object) =>
  action(CompaniesTypes.COMPANY_BOLETO_CONFIG_DELETE_REQUEST, payload);
export const companyBoletoConfigDeleteSuccess = () =>
  action(CompaniesTypes.COMPANY_BOLETO_CONFIG_DELETE_SUCCESS);
export const companyBoletoConfigDeleteFaliure = () =>
  action(CompaniesTypes.COMPANY_BOLETO_CONFIG_DELETE_FAILURE);
